import { render, staticRenderFns } from "./FiltersButton.vue?vue&type=template&id=0986ba5a&scoped=true"
import script from "./FiltersButton.vue?vue&type=script&lang=js"
export * from "./FiltersButton.vue?vue&type=script&lang=js"
import style0 from "./FiltersButton.vue?vue&type=style&index=0&id=0986ba5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0986ba5a",
  null
  
)

export default component.exports